import { styled } from '@mui/material';

export const SubmitCancelButtonsWrapper = styled('div')(({ theme }) => ({
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
}));
